import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';
import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';
import { apiBasePath, apiName } from 'assets/constants';
import {
  Mode,
  UseMicrobiomeAgeRangesResponse,
} from './types/microbiome-age.types';

async function getMicrobiomeAgeRanges(kitId: string, mode: Mode) {
  return API.get(
    apiName,
    `${apiBasePath}/microbiome-age/${kitId}/ranges?mode=${mode}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.RESULTS,
        importance: IMPORTANCE.HIGH,
      },
      context: {
        kitId,
      },
    },
  );
}

export default function useMicrobiomeAgeRanges(
  kitId: string,
  mode: Mode = 'single',
) {
  return useSuspenseQuery<UseMicrobiomeAgeRangesResponse>({
    queryKey: [apiName, 'getMicrobiomeAgeRanges', kitId, mode],
    queryFn: () => getMicrobiomeAgeRanges(kitId, mode),
  });
}
